import {jsx} from 'panel';

import type {Directions} from 'common/components/drop-menu/types';
import {userCookieUtils} from 'common/report/util/user-identity-from-cookie';
import type {DashboardSelectorController} from 'common/report/controllers/dashboard-selector-controller';

import {DashboardSelectorEl} from './index';

export function BoardsDashboardSelector({
  recentDashboardIds,
  placeholder,
  handleDashboardSelected,
  handleMenuChanged,
  dashboardController,
  direction,
  quickCreateSaveDashboardCopy,
  offset,
  open = true,
  alignRight,
  excludedDashboards,
  showProjectSelector,
}: {
  recentDashboardIds: number[];
  placeholder: string;
  handleDashboardSelected: (ev: CustomEvent) => void;
  handleMenuChanged?: (ev: CustomEvent) => void;
  dashboardController: DashboardSelectorController;
  quickCreateSaveDashboardCopy?: string;
  direction?: Directions;
  offset?: number;
  open?: boolean;
  alignRight?: boolean;
  excludedDashboards?: number[];
  showProjectSelector?: boolean;
}) {
  return (
    <DashboardSelectorEl
      attrs={{
        open,
        'compact-mode': true,
        direction,
        'disable-create-dashboard': true,
        'display-only-editable-dashboards': true,
        offset,
        'quick-create': true,
        'quick-create-save-dashboard-copy': quickCreateSaveDashboardCopy,
        'search-placeholder': placeholder,
        'show-creator-sublabel': true,
        'show-project-selector': showProjectSelector,
        'single-section': true,
        'user-id': userCookieUtils.getUserIdentityFromCookie()?.id,
      }}
      class={{
        'align-right': alignRight,
      }}
      on={{
        select: handleDashboardSelected,
        menuchange: handleMenuChanged,
      }}
      props={{
        excludedDashboards,
        controller: dashboardController,
        initialSortedDashboardIds: recentDashboardIds,
      }}
    />
  );
}
